import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

/** The blue LinkedIn tile with its white "in" glyph. */
const LinkedInIcon: React.FC<IconProps> = ({ className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className={className} {...props}>
    <rect x="20" y="20" width="216" height="216" rx="24" fill="currentColor" />
    <circle cx="76" cy="78" r="14" fill="#fff" />
    <rect x="64" y="102" width="24" height="82" fill="#fff" />
    <path
      fill="#fff"
      d="M106 102h23v11c7-11 18-16 31-16 25 0 38 16 38 46v41h-24v-38c0-14-5-24-18-24-16 0-26 11-26 30v32h-24v-82Z"
    />
  </svg>
);

export { LinkedInIcon };
export default LinkedInIcon;
